import { lazy } from 'react'

const DashboardAnalytics = lazy(() => import('../../views/dashboard-template/analytics'))
const DashboardEcommerce = lazy(() => import('../../views/dashboard-template/ecommerce'))
const DashboardSuperadmin = lazy(() =>
  import('../../views/dashboard/superadmin')
)

const DashboardRoutes = [

  {
    path: '/dashboard/analytics',
    element: <DashboardAnalytics />,
    meta: {
      layout: 'vertical'
    }
  },

  {
    path: '/dashboard/superadmin',
    element: <DashboardSuperadmin />
  },
  {
    path: '/dashboard/ecommerce',
    element: <DashboardEcommerce />
  }


  // {
  //   path: '/dashboard/concession/withdrawal',
  //   element: <DashboardConcession />
  // }
]

export default DashboardRoutes
